import React, { useState } from 'react';
import { Icon } from '@frontend/icons';
import { classNames } from '@frontend/string';
import { Heading, Text } from '@frontend/design-system';
import { card, cardHeaderWrapper, cardHeader, contents } from './styles';

interface Props {
  title: string;
  subTitle?: string;
  maxWidth?: number;
  children: React.ReactElement;
}

export default function CollapsibleCard({ title, subTitle, maxWidth, children }: Props) {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <section css={card(maxWidth)} className={classNames('collapsible-content', { open })}>
      <Heading css={cardHeaderWrapper} onClick={() => setOpen(!open)}>
        <div css={cardHeader} className='title-wrapper'>
          <Text as='h2' weight='regular' color='light'>
            {title}
          </Text>
          {!!subTitle && <Text as='h3'>{subTitle}</Text>}
        </div>
        <Icon name='caret-down' className='arrow-icon' />
      </Heading>
      <article css={contents}>{children}</article>
    </section>
  );
}
